import React from "react";

const AboutUsCard = ({ title, firstcontent, secondcontent }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden mx-4 md:mx-6 lg:mx-8 mb-6 transition-all duration-300 hover:shadow-2xl hover:scale-105 cursor-pointer">
      <div className="py-4 px-6 transition-all duration-300 hover:bg-teal-50">
        <h3 className="text-primary font-bold text-2xl lg:text-3xl text-center">
          {title}
        </h3>
      </div>
      
      <div className="px-6 pb-5">
        <p className="text-black text-sm lg:text-base py-2 leading-relaxed transition-all duration-300 hover:text-gray-800">
          {firstcontent}
        </p>
        <p className="text-black text-sm lg:text-base py-2 leading-relaxed transition-all duration-300 hover:text-gray-800">
          {secondcontent}
        </p>
      </div>
    </div>
  );
};

export default AboutUsCard;   